var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuiltOnSiaPrimaryDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 130.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1d2609",
    d: "M48.2,124.1c20,0,33.9-17,33.9-41.4s-14-41.5-33.9-41.5-22.8,11.4-24.5,14.9l-.7,1.4V4.4h-13.8v117.8h13.8v-13.4l.7,1.2c2.3,4.3,9.4,14.1,24.5,14.1ZM22.7,82.8c0-17.2,9.1-28.7,22.6-28.7s22.6,11.8,22.6,28.7-9.3,28.7-22.6,28.7-22.6-11.5-22.6-28.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d2609",
    d: "M127.9,124.1c16.7,0,33.5-10.1,33.5-32.8v-47.6h-13.8v46.8c0,12.6-7.5,20.5-19.7,20.5s-19.7-7.7-19.7-20.5v-46.8h-14.1v47.6c0,20.6,12.6,32.8,33.8,32.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#1d2609",
    x: 181.6,
    y: 45.3,
    width: 13.9,
    height: 78.9
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1d2609",
    x: 181.3,
    y: 7,
    width: 14.6,
    height: 22.3
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#1d2609",
    x: 216.7,
    y: 6.3,
    width: 13.9,
    height: 117.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d2609",
    d: "M291.9,124.1h16.7v-12.8h-13c-11.5,0-15.8-4.3-15.8-15.8v-37.7h28.8v-12.5h-28.8V10.5h-13.9v34.8h-20.8v12.5h20.8v40.8c0,17.2,8.5,25.6,26.1,25.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d2609",
    d: "M384.2,41.4c-21.8,0-37,17-37,41.4s15.2,41.4,37,41.4,37-17,37-41.4-15.2-41.4-37-41.4ZM384.2,111.3c-13.7,0-22.6-11.2-22.6-28.5s8.9-28.5,22.6-28.5,22.6,11.2,22.6,28.5-8.9,28.5-22.6,28.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d2609",
    d: "M471.3,56.3c12.5,0,19.7,8.6,19.7,23.5v44.3h14.1v-47c0-20.7-11.6-33.6-30.2-33.6s-20.3,7.7-23.5,14.9l-.7,1.5v-14.7h-13.9v78.9h13.9v-44.3c0-15,7.5-23.5,20.6-23.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#c3e600",
    x: 730.3,
    y: 10.5,
    width: 12.5,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e50aae",
    x: 717.8,
    y: 10.5,
    width: 12.5,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#36d955",
    x: 730.3,
    y: 23,
    width: 12.5,
    height: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d2609",
    d: "M631.2,123.6h19.6v-11.8h-19.6v11.8ZM598.6,123.6h19.6v-11.8h-19.6v11.8ZM704.8,123.6h13.1v-11.8h-13.1v11.8ZM663.9,123.6h27.9v-11.8h-27.9v11.8ZM544.9,123.6h40.6v-11.8h-40.6v11.8h0ZM618.8,30.7h11.8V10.5h-11.8v20.2ZM695.7,78.2h-4v33.6h13.1v-47.9c.2-11.9-8.4-19.9-21.5-19.9h-31.5v11.5h29.6c6.7-.2,11,3.2,11,8.6-.2,5.9-3.8,8.1-13.5,11.3l-8.6,2.9c-13.7,4.5-19.4,12.3-19.4,23.1v10.5h13.1v-8.4c0-7.3,2.9-10.5,12.6-14.3l8.6-3.3c4.1-1.6,8-3.7,10.7-7.5h0l-.2-.2ZM618.1,111.8h13.1V43.9h-13.1v67.8h0ZM585.5,111.8h13.1v-11c0-11-5.9-17.8-20.4-22.6l-8.6-2.9c-9.6-3.2-13.4-5.1-13.4-11.5s4.6-8.4,10.5-8.4h30.9v-11.5h-32.8c-12.3,0-21.2,7.5-21.2,19.7s6.5,18.2,19.7,22.6l8.6,2.9c11.8,4,13.5,6.5,13.5,14.2v8.4h.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuiltOnSiaPrimaryDark);
export default __webpack_public_path__ + "static/media/built-on-sia-primary-dark.ba9185968ea7178e0183c1479172e60c.svg";
export { ForwardRef as ReactComponent };